
    function cartGetOffDays(bo){
      let off = []

      if(bo){
          for(bos of bo){
              try{
                  let date = moment(bos, 'DDMMYYYY').format('DD/MM/YYYY')
                  if(date !== 'Invalid date'){
                      off.push(date)
                  }
                } catch(err){
                    console.log(err)
                  }
          }
      }

      return off
    }

    async function checkItems(itemsTags){
      const itemsCannotDeliver = [];
      const cart = await fetch('/cart.js').then(result => result.json())
      let itemProps = cart.items.map(i => i.properties)
      itemsTags.forEach((item, index) => {
          let { deliverOnMonToSat, deliverOnWeekend, bia, sameDayTag, blockSat, blockSun, bo } = item

          let sameDayCutOffTime = 12

          if (sameDayTag) {
            var cutOffHour = sameDayTag.toLowerCase().replace('same-day-', '')
            sameDayCutOffTime = moment(cutOffHour, 'Ha').hour();
          }

          if(!itemProps[index]['Delivery']){
              return
          }

          const timeNow = moment().utcOffset(8, true)
          const hourNow = moment().utcOffset(8)
          const itemDD = moment(itemProps[index]['Delivery'], 'DD/MM/YYYY').utcOffset(8, true)

          if(timeNow.isSame(itemDD, 'day') && hourNow.hour() >= sameDayCutOffTime){
              itemsCannotDeliver.push({
                  index,
                  sameDayCutOffTime
              })
              return
          }

          if(timeNow.isAfter(itemDD, 'day')){
              itemsCannotDeliver.push({
                  index,
                  deliveryDatePassed: true
              })
              return
          }

          if (bia && bia == '0' && blockSat && moment(timeNow).day() == 6) {
              itemsCannotDeliver.push({
                  index,
                  blockSat
              })
          }

          if (bia && bia == '0' && blockSun && moment(timeNow).day() == 0) {
              itemsCannotDeliver.push({
                  index,
                  blockSun
              })
          }

          if (bia && bia !== '0' && moment(timeNow).add(Number(bia), 'day').isAfter(itemDD, 'day')) {
            itemsCannotDeliver.push({
              index,
              bia
            })
            return
          }
      })
      return itemsCannotDeliver
    }

  async function checkTags(index) {
    let newItemsTags = [];
    let cart = await fetch('/cart.js').then(result => result.json())
    let cartItems = [...cart.items]
    if (index >= 0) {
      cartItems = [cartItems[index]]
    }

    function getProductTags(handle){
      return new Promise(function(resolve, reject){
        return getShopifyProduct(handle).then(product => {
          productResult = {deliverOnWeekend: true}
          for (let tag of product.tags){
            tag = tag.toLowerCase()
            if (tag.includes('self')) {
              productResult.selfPickup = true;
            }
            if(tag.includes('same-day-')){
              productResult.sameDayTag = tag;
            }
            if(tag.includes('block-sat')){
              productResult.blockSat = true;
            }
            if(tag.includes('block-sun')){
              productResult.blockSun = true;
            }
            if(tag.includes('bia-')){
              tag.split('-').forEach((biaSplit, i) => {
                if(i == 1){
                  productResult.bia = biaSplit
                }
                if(i == 2 && (biaSplit == 'nw')){
                  productResult.deliverOnWeekend = false
                }
                if(i == 2 && (biaSplit == 'ws')){
                  productResult.deliverOnMonToSat = true
                }
              })
            }
            if (tag.includes('ubia-')) {
              productResult.seasonal = true
            }
            if (tag.includes('bo-') && !tag.includes('ubo-')) {
              let boDate = tag.split('-')[1]
              if (!productResult.bo) {
                productResult.bo = [boDate]
              } else {
                productResult.bo.push(boDate)
              }
            }
            if (tag.includes('ubo-')) {
              let uboDate = tag.split('-')[1]
              if (!productResult.ubo) {
                productResult.ubo = [uboDate]
              } else {
                productResult.ubo.push(uboDate)
              }
            }
            if (tag.includes('closed-')) {
              let closed = tag.split('-')[1]
              if (!productResult.closed) {
                productResult.closed = [closed]
              } else {
                productResult.closed.push(closed)
              }
            }
            if(tag.includes('enable_vm')){
              productResult.enableVm = true
            }
            if(tag === 'byog') {
              productResult.isByog = true
            }
          }
          newItemsTags.push(productResult)
          resolve()
        })
      })
    }

    while(cartItems.length){
      await getProductTags(cartItems.splice(0,1)[0].handle)
    }

    return newItemsTags;

  }

  $('.custom-checkout').on('click', async function(e){
    e.preventDefault();
    $('.custom-checkout').prop('disabled', true)
    try {
      const tags = await checkTags();
      const itemsCannotDeliver = await checkItems(tags);
      if(itemsCannotDeliver.length > 0){
          for (item of itemsCannotDeliver){

              const itemProps = document.querySelectorAll(`#item-title-${item.index} .msg-properties`)
              const deliveryProp = Array.from(itemProps).filter(node => node.innerText.includes('Delivery'))[0]

              let tempSpan = document.createElement('span')
              tempSpan.className = 'delivery-error'
              tempSpan.style.color = 'red'
              tempSpan.style.display = 'block'

              if(item.deliveryDatePassed){
                tempSpan.innerText = 'The delivery date for this item has passed. Please select another delivery date.'
              } else if (item.bia) {
                tempSpan.innerText = `This item requires ${item.bia} day(s) booking in advance. Please select another delivery date.`
              } else if (item.sameDayCutOffTime) {
                tempSpan.innerText = `Sorry to inform that order has to be placed before ${item.sameDayCutOffTime > 12 ? item.sameDayCutOffTime-12 : item.sameDayCutOffTime}pm for same day delivery. Please select another delivery date.`
              } else if (item.blockSat) {
                tempSpan.innerText = `Sorry to inform that same day delivery is not available for this product on Saturday. Please select another delivery date.`
              } else if (item.blockSun) {
                tempSpan.innerText = `Sorry to inform that same day delivery is not available for this product on Sunday. Please select another delivery date.`
              }

              deliveryProp.insertAdjacentElement('afterend', tempSpan)
          }
          return
      }
      const cart = await fetch('/cart.js').then(result => result.json())

    let bulkProductsCount = 0
    for (let item of cart.items) {
        const foundBulkProduct = Object.keys(item.properties).find(key => {
            if(key.toLowerCase().match(/^\+ shipping fee/g)){
                return true
            }
        })

        if (foundBulkProduct) {
            bulkProductsCount += 1;
        }
    }

    if (bulkProductsCount > 0) {
      if (bulkProductsCount !== cart.items.length) {
        $(`#bulk-warning`).css('display', 'block')
        console.log("We've noticed that you have corporate bulk orders in the cart along with other product(s). Please proceed to checkout separately to ensure that payment can be processed smoothly without exceeding payment limit.");
        $('.custom-checkout').prop('disabled', false)
        return
      }

      var body = {
        cart: cart.items,
      };

      if (document.getElementById('senders-phone-number')) {
        body.senderNo = document.getElementById('senders-phone-number').value;
      }

      if (customerId) {
        body.customer = {
          customerId: 'gid://shopify/Customer/' + customerId
        };
      }

      fetch('https://app.giftr.my/api/checkout/addons', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(body)
      }).then(res => res.json()).then(checkoutUrl => {
        window.location = checkoutUrl
      }).catch(err => {
        throw err;
      })

      return;
    }

      document.getElementById(e.target.id === 'mobile-checkout-button' ? 'mobile-submit-checkout' : 'submit-checkout').click();
    } catch(err) {
      console.log(err)
    }
    $('.custom-checkout').prop('disabled', false)
  })

  async function editVisibility(){
    var itemsTags = await checkTags();

    // show virtual message previews
    itemsTags.forEach((item, i) => {

      if (item.isByog) {
        $(`#props${i}`).prevAll('a').find('#edit-bng').css('display', 'inline-block')
        return
      }

      if(item.enableVm){
        $(`#props${i}`).find('.edit-vm').css('display', 'inline')

      } else {
        $(`#props${i}`).find('.edit-tm').css('display', 'inline')
      }

    })
  }
  editVisibility();
  updateAddOnsPrice(); // add-ons.js.liquid


$(window).load(function() {
  $(".edit-delivery").click(async function() {
    $('#loading').show()
    var index = parseInt($(this).parents(".line-item-props").attr('id').slice(-1));
    var itemsTags = await checkTags(index);

    $('#date').val(CartJS.cart.items[index].properties['Delivery'])
    $('#line-item').val(index)
    let tags = itemsTags[0]

    $('#date').datepicker('remove');
    console.log(tags)

    var bia = parseInt(tags.bia);
    var sameDayTag = tags.sameDayTag;
    var blockSat = !!tags.blockSat
    var blockSun = !!tags.blockSun
    var offDays = tags.seasonal ? getOffDays(tags.ubo, true) : getOffDays(tags.bo);
    var isTodayOff = false;
    var sameDayCutOffTime = 12
    var now = moment().utcOffset(8)

    if (sameDayTag) {
      var cutOffHour = sameDayTag.toLowerCase().replace('same-day-', '')
      sameDayCutOffTime = moment(cutOffHour, 'Ha').hour()
    }

    for (i = 0; i < offDays.length; i++) {
      if (now.format("DD/MM/YYYY") == offDays[i]){
        isTodayOff = true;
      }
      if (!tags.deliverOnMonToSat && now.day() == 6) {
        isTodayOff = true;
      } else if (!tags.deliverOnWeekend && (now.day() == 0 || now.day() == 6)) {
        isTodayOff = true;
      }
    }

    if((bia == 0 && now.hour() >= sameDayCutOffTime) || (bia == 0 && isTodayOff)){
      bia++;
    } else if (tags.deliverOnMonToSat && (bia == 0 && blockSat && now.day() == 6)) {
      bia++;
    } else if (tags.deliverOnWeekend && ((bia == 0 && blockSat && now.day() == 6) || (bia == 0 && blockSun && now.day() == 0))) {
      bia++;
    }

    let option = {
      format: "dd/mm/yyyy",
      maxViewMode: 0,
      datesDisabled: offDays,
      startDate: moment().utcOffset(8).add(bia, 'days').format("DD/MM/YYYY"),
      endDate: moment().utcOffset(8).add(60, 'days').format("DD/MM/YYYY")
    }

    let weeklyOffDays = [0, 6]
    if (tags.deliverOnMonToSat) {
      weeklyOffDays = [0]
    } else if (tags.deliverOnWeekend) {
      weeklyOffDays = []
    }

    option.daysOfWeekDisabled = weeklyOffDays.concat(getWeeklyOffDays(tags.closed))

    $('#date').datepicker(option);
    $('#date').datepicker('update');

    document.getElementById('edit-delivery-overlay').classList.add('fading-in')
    document.getElementById('edit-delivery-popup').classList.add('fading-in')
    $('#loading').hide()
  })
})


function getOffDays(bo, seasonal = false){
  var off = [];

  if (!bo) {
    return off
  }

  if (seasonal) {
    function remove(array, element) {
      const index = array.indexOf(element);


      if (index !== -1) {
        array.splice(index, 1);
      }
    }

    for (var i = 0; i < 63; i++) {
      var date = moment().add(i, 'days').format("DD/MM/YYYY")
      off.push(date)
    }

    for (let bos of bo) {
      try {
        var date = moment(bos, "DDMMYYYY").format("DD/MM/YYYY")
        if (date !== 'Invalid date') {
          remove(off, date)
        }

      } catch (err) { }
    }

    return off
  }

  for (let bos of bo) {
    try{
      var date = moment(bos, "DDMMYYYY").format("DD/MM/YYYY")
      if(date !== 'Invalid date'){
        off.push(date)
      }

    }catch(err){}
  }

  return off
}

function getWeeklyOffDays(closed) {
  var close = [];

  if (!closed) {
    return close
  }

  for (let c of closed) {
    close.push(c)
  }

  return close
}

function closeEditDeliveryPopup() {
  document.getElementById('edit-delivery-overlay').classList.remove('fading-in')
  document.getElementById('edit-delivery-popup').classList.remove('fading-in')
}

function saveDeliveryDate() {
  let index = parseInt($('#line-item').val())
  let date = $('#date').val()
  let properties = CartJS.cart.items[index].properties
  let quantity = CartJS.cart.items[index].quantity

  properties['Delivery'] = date
  CartJS.updateItem(index + 1, quantity, properties);

  document.getElementById('edit-delivery-overlay').classList.remove('fading-in')
  document.getElementById('edit-delivery-popup').classList.remove('fading-in')

  $('.delivery-error').remove()
  $('.custom-checkout').prop('disabled', false)
}
